import { DialogRef } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Output
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {
  filter,
  map,
  Observable,
  startWith
} from 'rxjs';
import { AsyncPipe } from '@angular/common';

import { AuthState } from '@app/modules/users';
import { LOCALE_NAMES, SupportedLocale } from '@env';

import { LocaleFlagPipe } from '../../pipes/locale-flag.pipe';

@Component({
  selector: 'choose-language-dialog',
  templateUrl: './choose-language.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocaleFlagPipe, AsyncPipe]
})
export class ChooseLanguageDialog {
  public readonly dialogRef = inject(DialogRef);
  public readonly authState = inject(AuthState);
  public readonly router = inject(Router);

  public readonly LOCALE_NAMES = LOCALE_NAMES;

  public readonly currentPath$: Observable<string> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(() => this.router.url),
    startWith(this.router.url)
  );

  @Output()
  public languageSelected = new EventEmitter<boolean>();

  public readonly countryCode = this.authState.countryCode()?.toLowerCase();

  selectedLocale(): SupportedLocale {
    return this.countryCode && LOCALE_NAMES[this.countryCode as SupportedLocale]
      ? (this.countryCode as SupportedLocale)
      : 'en';
  }

  onLanguageChoice(): void {
    this.languageSelected.emit(true);
    this.dialogRef.close(true);
  }

  selectedLanguageName(): string {
    return LOCALE_NAMES[this.selectedLocale()] || 'English';
  }

  generateLocaleUrl(currentPath : string): string {
    return `/${this.selectedLocale()}${currentPath || '/'}`;
  }

  generateUkrainianUrl(currentPath: string): string {
    return `/uk${currentPath || '/'}`;
  }
}
